import dayjs from '../../utils/dayjs';

import helpers from 'helpers/index';
import Pagination from 'components/pagination';
import SimpleFilter from 'components/simpleFilter';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import TransactionsCallbackModal from './transactions_callback.modal';
import TransactionsCallbackCreateModal from './transactions_callback.create.modal';
import { TypedTransactions_callback, useGetTransactionsCallback, useMutateResyncTransactionCallback } from 'queries/transactions.query';
import { Helmet } from 'react-helmet-async';
import { Badge, Button, Card, DataTable, InlineStack, Page, Text } from '@shopify/polaris';
import { ___ } from 'languages/index';
import { EditIcon, PlusIcon, RefreshIcon } from '@shopify/polaris-icons';

export default function TransactionsCallback() {
  const rootSearchPath = window.location.search;
  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  let StringQuery: any = helpers.ExtractUrl(rootSearchPath) || false;
  const initialQuery = {
    query: '',
    page: 1,
    limit: 50,
    sort: 'id:desc',
  };
  const [mainQuery, setMainQuery] = useState<any>({
    ...initialQuery,
    ...StringQuery,
  });
  const { refetch: getEntities, data, isFetching: loading } = useGetTransactionsCallback(mainQuery);

  const [entities, setEntities] = useState<TypedTransactions_callback[]>([]);
  const [totalItems, setTotalItems] = useState(0);
  useEffect(() => {
    if (data) {
      let { entities, totalItems } = data;
      setEntities(entities);
      setTotalItems(totalItems);
    }
  }, [data]);
  /**
   * Change page number
   * Must be mainQuery or it will reset mainQuery. BUG!
   */
  const onChangePagination = useCallback((numPage: number, limit: number) => {
    setMainQuery((prevMainQuery) => ({ ...prevMainQuery, page: numPage, limit: limit }));
  }, []);

  const reduceRequest = useCallback((mainQuery) => {
    getEntities();
    return mainQuery;
  }, []);

  const reduceRequestMemo = useMemo(() => {
    return helpers.debounce((_value) => {
      reduceRequest?.call(this, _value);
    }, 500);
  }, []);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (window.location.search !== buildURLSearch) {
      window.history.replaceState(null, 'Transactions Callback', '/transactions_callback' + buildURLSearch);
    }
    reduceRequestMemo(mainQuery);
  }, [mainQuery]);

  /** Sync laij duwx lieeuj */
  const currentSyncID = useRef(null);
  const { mutateAsync: resyncCB, isPending: loadingSync } = useMutateResyncTransactionCallback();
  const reSyncTransactions = useCallback(async (transactions_callback_id) => {
    //
    currentSyncID.current = transactions_callback_id;
    try {
      await resyncCB(transactions_callback_id);
    } catch (e) {}
  }, []);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const currentEntity = useRef<TypedTransactions_callback>(null);

  return (
    <>
      <Helmet>
        <title>Giao dịch callback</title>
      </Helmet>
      <Page
        title="Giao dịch callback"
        fullWidth
        primaryAction={{
          content: 'Thêm giao dịch callback',
          icon: PlusIcon,
          onAction: () => setShowCreateModal(true),
        }}
      >
        <Card padding="0">
          <SimpleFilter loading={loading} options={[]} onCallback={filterCallback} sortField={[]} />
          <DataTable
            verticalAlign="middle"
            hideScrollIndicator={true}
            stickyHeader
            increasedTableDensity
            columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'numeric']}
            headings={['ID', 'Số tiền', 'Tình trạng', 'Lúc', 'Từ ngân hàng', 'Tên người gửi', 'Mã đơn', 'Nội dung', 'Ghi chú', 'Ngày tạo', 'Công cụ']}
            rows={
              entities?.map((transaction_callback) => {
                const { id, amount, is_valid, timestamp, from_bank, from_name, content, note, createdAt, bank_order_id } = transaction_callback;

                return [
                  id,
                  helpers.formatNumberWithCommas(amount),

                  is_valid ? <Badge tone="success">HỢP LỆ</Badge> : <Badge tone="critical">KHÔNG HỢP LỆ</Badge>,

                  <>
                    <Text as="h3" variant="headingMd">
                      {dayjs(new Date(Number(timestamp))).format('HH:mm')}
                    </Text>
                    <Text as="p" tone="subdued">
                      {dayjs(new Date(Number(timestamp))).format('DD-MM-YYYY')}
                    </Text>
                  </>,

                  from_bank,
                  from_name,
                  bank_order_id,
                  content,
                  note ? (
                    <Text as="span" tone="critical">
                      {note}
                    </Text>
                  ) : (
                    '--'
                  ),

                  <>
                    <Text as="h3" variant="headingMd">
                      {dayjs(new Date(Number(createdAt))).format('HH:mm')}
                    </Text>
                    <Text as="p" tone="subdued">
                      {dayjs(new Date(Number(createdAt))).format('DD-MM-YYYY')}
                    </Text>
                  </>,

                  !is_valid ? (
                    <InlineStack align="start" blockAlign="center" gap="400">
                      <Button
                        variant="plain"
                        loading={loadingSync && currentSyncID.current === id}
                        onClick={() => {
                          reSyncTransactions(id);
                        }}
                        icon={RefreshIcon}
                      >
                        Xét lại
                      </Button>

                      <Button
                        variant="plain"
                        icon={EditIcon}
                        onClick={() => {
                          currentEntity.current = transaction_callback;
                          setShowEditModal(true);
                        }}
                      >
                        Edit
                      </Button>
                    </InlineStack>
                  ) : null,
                ];
              }) || []
            }
            footerContent={___('Show page {display_page_number} of {total_record_number} results', {
              display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
              total_record_number: <Text as="strong">{totalItems}</Text>,
            })}
          />
        </Card>

        <br />
        {totalItems > 0 ? (
          <Pagination
            TotalRecord={totalItems}
            onChange={onChangePagination}
            pageSize={Number(mainQuery?.limit)}
            activeCurrentPage={Number(mainQuery?.page)}
          />
        ) : null}
      </Page>
      <br />
      <br />
      <br />
      <br />

      <TransactionsCallbackModal
        show={showEditModal}
        currentEntity={currentEntity.current}
        onClose={() => {
          setShowEditModal(false);
          currentEntity.current = null;
        }}
      />

      <TransactionsCallbackCreateModal open={showCreateModal} onClose={() => setShowCreateModal(false)} />
    </>
  );
}
